import React, { useState, useEffect } from 'react';
import { 
  Box, 
  Button, 
  Typography, 
  Table, 
  TableBody, 
  TableCell, 
  TableContainer, 
  TableHead, 
  TableRow, 
  Paper, 
  CircularProgress,
  Stack,
  Alert
} from '@mui/material';
import MapIcon from '@mui/icons-material/Map';
import RefreshIcon from '@mui/icons-material/Refresh';

const InteligenciaImpactos = () => {
  const [impactos, setImpactos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [mensagem, setMensagem] = useState(null);

  // Simulação de carregamento de dados da tabela impacto_referencia
  const carregarImpactos = async () => {
    // Aqui viria seu fetch para o Django
    // Ex: const response = await fetch('/api/impactos/');
  };

  const handleGerarJanelas = async () => {
    setLoading(true);
    setMensagem({ tipo: 'info', texto: 'Mapeando feriados e gerando janelas no banco...' });
    // Logica para chamar o backend
    setTimeout(() => {
      setLoading(false);
      setMensagem({ tipo: 'success', texto: 'Janelas geradas com sucesso para o ano atual!' });
    }, 2000);
  };

  const handleRecalcularImpactos = async () => {
    setLoading(true);
    setMensagem({ tipo: 'warning', texto: 'Recalculando matriz de impactos. Isso pode levar alguns minutos...' });
    // Logica para processar o histórico
    setTimeout(() => {
      setLoading(false);
      setMensagem({ tipo: 'success', texto: 'Matriz de impactos atualizada com base no histórico!' });
    }, 3000);
  };

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold' }}>
        Matriz de Impactos (Fatores de Venda)
      </Typography>
      
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Configure como cada evento afeta o volume de vendas e mapeie o calendário de feriados.
      </Typography>

      {/* Ações Principais */}
      <Stack direction="row" spacing={2} sx={{ mb: 4 }}>
        <Button 
          variant="contained" 
          startIcon={loading ? <CircularProgress size={20} color="inherit" /> : <MapIcon />}
          onClick={handleGerarJanelas}
          disabled={loading}
        >
          Gerar Janelas e Mapear Feriados
        </Button>
        
        <Button 
          variant="outlined" 
          color="secondary"
          startIcon={loading ? <CircularProgress size={20} color="inherit" /> : <RefreshIcon />}
          onClick={handleRecalcularImpactos}
          disabled={loading}
        >
          Recalcular Multiplicadores
        </Button>
      </Stack>

      {mensagem && (
        <Alert severity={mensagem.tipo} sx={{ mb: 3 }} onClose={() => setMensagem(null)}>
          {mensagem.texto}
        </Alert>
      )}

      {/* Tabela de Referência */}
      <TableContainer component={Paper} sx={{ maxHeight: 600 }}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontWeight: 'bold' }}>Categoria</TableCell>
              <TableCell align="center" sx={{ fontWeight: 'bold' }}>Offset (Dias)</TableCell>
              <TableCell align="right" sx={{ fontWeight: 'bold' }}>Multiplicador</TableCell>
              <TableCell align="right" sx={{ fontWeight: 'bold' }}>Impacto %</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {/* Exemplo de dados vindos do banco */}
            {[
              { cat: 'SEGUNDA', offset: -1, fator: 1.7851 },
              { cat: 'SEGUNDA', offset: 0, fator: 1.1092 },
              { cat: 'CARNAVAL', offset: -3, fator: 1.2500 },
            ].map((row, index) => (
              <TableRow key={index} hover>
                <TableCell>{row.cat}</TableCell>
                <TableCell align="center">{row.offset}</TableCell>
                <TableCell align="right">{row.fator.toFixed(4)}</TableCell>
                <TableCell align="right" sx={{ color: row.fator > 1 ? 'green' : 'red' }}>
                  {((row.fator - 1) * 100).toFixed(2)}%
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default InteligenciaImpactos;